import { render } from "./main.vue?vue&type=template&id=4a0fe172&scoped=true&ts=true"
import script from "./main.vue?vue&type=script&lang=ts"
export * from "./main.vue?vue&type=script&lang=ts"

import "./main.vue?vue&type=style&index=0&id=4a0fe172&scoped=true&lang=css"
import "./main.vue?vue&type=style&index=1&id=4a0fe172&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a0fe172"]])

export default __exports__